import React, { Fragment, useRef, useState } from 'react'
import Chart from 'react-apexcharts'
import { Card, CardBody, CardHeader, Col, Media, Row, Table, Container, NavItem, NavLink, Nav, TabContent, TabPane } from 'reactstrap'
import 'animate.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { InputText } from "primereact/inputtext";



export const ComponentDetailPatient = (props) => {

  const { patient_excluded, number_format, exportToExcel, navigateDetailPatient, setSelectedRows, buildSelectedValues, selectedRows } = props;


  //* CONFIGURACIÓN DEL GRÁFICO DE BARRAS
  const nims = [];
  const data = [];
  const colors1 = [];

  patient_excluded.forEach(_find => {

    const amount = parseFloat(_find.amount) || 0;
    const nim = _find.nim ?? "";
    const isTrue = _find.patient_invoice === "False";

    data.push(amount);
    nims.push(nim);
    colors1.push(isTrue ? "#dc3545" : "#51bb25");
  });

  const headerStyle = {
    backgroundColor: "#1d5b83",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "11px",
    borderRight: "1px solid #fff",
    borderBottom: "2px solid #fff",
  };

  const cellStyle = {
    fontSize: "11px",
    padding: "5px",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",

  };

  const centerStyle = {
    ...cellStyle,
    textAlign: "center",
    zIndex: 2
  };




  //*CONFIGURATION TABLE
  const [expandedRows, setExpandedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null)

  const tagInfo = (rowData) => {

    if (rowData.patient_invoice === "False") {
      return <Tag style={{ fontSize: "11px" }} className="mr-2" severity='danger' value={rowData.nim} onClick={rowData.patient_invoice === "False" ? "" : () => navigateDetailPatient(rowData?.id_workOrder)}  ></Tag>;
    }
    return <Tag className="mr-2 pointer" style={{ fontSize: "11px" }} severity='warning' value={rowData.nim} onClick={rowData.patient_invoice === "False" ? "" : () => navigateDetailPatient(rowData?.id_workOrder)}  ></Tag>;
  };

  const getValueTax = (_valueTax) => {
    if (_valueTax.patient_invoice === "False") {
      return <i className="fa fa-check txt-success"></i>;
    }
    return <i className="fa fa-times txt-danger"></i>;
  };



  const getamount = (rowData) => {
    if (rowData.patient_invoice === "False") {
      return <b className='txt-danger' style={{ fontSize: "11px" }} > ${number_format(rowData?.amount, 2) ?? 0}</b>;
    }
    return <b style={{ fontSize: "11px" }} > ${number_format(rowData?.amount, 2) ?? 0}</b>;
  };



  return (
    <>
      <Col sm="12" className='p-l-0 p-r-0' >
        <Col sm="12" className='pt-2 pb-2' >
          <Row>
            <Col sm="8">
              <button
                className="p-button p-button-success"
                onClick={() => exportToExcel(patient_excluded)}
                title="Descargar reporte"
                style={{
                  alignItems: "center",
                  padding: "5px 8px",
                  height: "35px",
                  width: "35px",
                  fontSize: "0.9rem",
                  display: "flex",
                  justifyContent: "center",
                  position: "relative"
                }}
              >
                <i className="pi pi-file-excel" style={{ fontSize: "1rem" }}></i>
              </button>
            </Col>
            <Col sm="4" style={{ textAlign: "end" }} >
              <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" className="pl-6" onInput={(e) => setGlobalFilter(e.target.value)} style={{ width: "auto" }} />
              </span>
            </Col>
          </Row>
        </Col>
        <DataTable
          value={patient_excluded}
          selection={selectedRows}
          dataKey="nim"
          paginator
          rows={10}
          onSelectionChange={(e) => {
            const allowed = e.value.filter(row => row.required_invocie !== "true");
            setSelectedRows(allowed);
            buildSelectedValues(allowed);
          }}
          rowsPerPageOptions={[10, 20, 30, 50]}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          className="data-table"
          responsiveLayout="scroll"
          style={{ fontSize: "8px" }}
          globalFilter={globalFilter}
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: '3rem' }}
            style={{ textAlign: 'center' }}
            selectionDisabled={(rowData) => rowData.required_invocie === "true"}
          />

          <Column header="#" body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} />
          <Column field="date_workorder" header="Fecha de admisión" headerStyle={headerStyle} style={centerStyle} />
          <Column header="Nim" body={(row) => tagInfo(row)} headerStyle={headerStyle} style={centerStyle} />
          <Column field="patient" header="Paciente" headerStyle={headerStyle} style={centerStyle} />
          <Column field="name_branch" header="Sucursal" headerStyle={headerStyle} style={centerStyle} />
          <Column header="Facturado" body={(row) => getValueTax(row.patient_invoice)} headerStyle={headerStyle} style={centerStyle} />
          <Column header="Monto" body={(row) => getamount(row)} headerStyle={headerStyle} style={centerStyle} />
          <Column field="user_required" header="Solicito" headerStyle={headerStyle} style={centerStyle} />
          <Column field="authorized" header="Autorizo" headerStyle={headerStyle} style={centerStyle} />
        </DataTable>

        {/* <DataTable
          value={patient_excluded}
          selection={selectedRows}
          dataKey="nim"
          paginator
          rows={10}
          onSelectionChange={(e) => {
            setSelectedRows(e.value);
            buildSelectedValues(e.value);
          }}
          selectionMode="checkbox"

          rowsPerPageOptions={[10, 20, 30, 50]}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          className="data-table"
          responsiveLayout="scroll"
          emptyMessage={
            <div className="text-center">
              <img
                src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                style={{ width: "45%" }}
                alt="Sin resultados"
              />
              <br />
              <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                No hay coincidencias con la búsqueda.
              </p>
            </div>
          }
          style={{ fontSize: "8px" }}
          globalFilter={globalFilter}

        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: '3rem' }}
            style={{ textAlign: 'center' }}
            selectionDisabled={(rowData) => rowData.required_invocie === "true"}

          />

          <Column header="#" body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} />
          <Column field="date_workorder" header="Fecha de admisión" headerStyle={headerStyle} style={centerStyle} />
          <Column header="Nim" body={(row) => tagInfo(row)} headerStyle={headerStyle} style={centerStyle} />
          <Column field="patient" header="Paciente" headerStyle={headerStyle} style={centerStyle} />
          <Column field="name_branch" header="Sucursal" headerStyle={headerStyle} style={centerStyle} />
          <Column header="Facturado" body={(row) => getValueTax(row.patient_invoice)} headerStyle={headerStyle} style={centerStyle} />
          <Column header="Monto" body={(row) => getamount(row)} headerStyle={headerStyle} style={centerStyle} />
          <Column field="user_required" header="Solicito" headerStyle={headerStyle} style={centerStyle} />
          <Column field="authorized" header="Autorizo" headerStyle={headerStyle} style={centerStyle} />

        </DataTable> */}
        <br />
      </Col> <br />
    </>
  )
}
